import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import "../../../assets/scss/components/track/analyseView.scss";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { StoreState } from "../../../types/models/store";
import TrackLayout from "../../../components/layout/track";
import Waveform from "../../../components/widgets/webform";
import { DefaultButton, Icon } from "../../../components/widgets";
import { getSearchTrackList, urlTrackToAnalyzeByCutrackNet } from "../../../actions/user";
import { LoadingWidget } from "../../../components/widgets/loading";
import { friendlyTimeBySecond } from "../../../utils";

export const TrackViewPage: React.FC = () => {
  const { id } = useParams();
  const { track_filter } = useSelector((state: StoreState) => state.auth);
  const navigate = useNavigate();
  const [fileData, setFileData] = useState<any>({});
  const [track_select, setTrackSelect] = useState<any>({});
  const initPlaying = {
    origin: false,
    id3_track: false,
    fp_track: false,
    wm_track: false,
    similiar: -1,
  };
  const [playing, setPlay] = useState<any>(initPlaying);
  const metatype = [
    {
      key: "id3_track",
      title: "ID3",
    }, {
      key: "fp_track",
      title: "FP",
    }, {
      key: "wm_track",
      title: "WM",
    }
  ];
  const [modalData, setModalData] = useState<any>({
    show: false,
    url: '',
  });
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (
      (track_filter.genre.length ||
        track_filter.mood.length ||
        track_filter.artist.length ||
        track_filter.composer.length ||
        track_filter.tempo.length) && !loading
    )
      navigate('/all-tracks');
  }, [track_filter]);

  useEffect(() => {
    const trackId = id?.split('&')[0];
    const fileId = id?.split('&')[1];
    getSearchTrackList({
      pagination: {
        page: 0,
        pages: 0,
        size: 1,
        total: 0
      },
      filter: {
        artist: [],
        composer: [],
        genre: [],
        mood: [],
        tempo: [],
        keyword: "",
        sort_by: "alpha",
        id: trackId,
      },
    })
      .then(async (data) => {
        if (data.result?.list?.length) setTrackSelect(data.result.list[0]);
      });
    let url = `https://prelistening.cugate.com/?i=${fileId}&dl=1`;
    urlTrackToAnalyzeByCutrackNet(url).then((res) => {
      setLoading(false);
      let analyzedata = res?.data?.data?.result ? res?.data?.data?.result : {};
      setFileData({
        // filedata: upload[0],
        url: url,
        // metadata: upload[0].metadata ? JSON.parse(upload[0].metadata) : {},
        analyzedata: analyzedata,
      });
    });
  }, [id]);

  return (
    <TrackLayout pageClass={"page-analyse-view mb-3"}>
      {`${track_select?.id}&${track_select?.file_info?.id}` === id && (
        <div className={"file-upload-box text-center "}>
          <div className="file-upload-wrapper uploaded_tracks">
            <div className="uk-container-large py-4">
              {fileData.url && (<Waveform playing={playing.origin} url={fileData.url} />)}
              <div className="d-flex mt-4 justify-content-between px-4">
                <div className="d-flex control left">
                  <div className="focus me-4" onClick={() => {
                    setPlay({
                      ...initPlaying,
                      origin: !playing.origin
                    });
                  }}>
                    {!playing.origin ? (
                      <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.0657 26.5C20.2454 26.5 26.0657 20.6797 26.0657 13.5C26.0657 6.3203 20.2454 0.5 13.0657 0.5C5.88597 0.5 0.0656738 6.3203 0.0656738 13.5C0.0656738 20.6797 5.88597 26.5 13.0657 26.5Z" fill="#037A9A" />
                        <path d="M9.38232 13.5V8.84165C9.38232 8.29998 9.92399 7.97498 10.4657 8.19165L14.474 10.4666L18.4823 12.7416C18.9157 12.9583 18.9157 13.7166 18.4823 13.9333L14.474 16.2083L10.4657 18.4833C10.0323 18.7 9.38232 18.375 9.38232 17.8333V13.5Z" fill="white" />
                      </svg>
                    ) : (
                      <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_1698_5897)">
                          <path d="M13.5745 26.5C20.7542 26.5 26.5745 20.6797 26.5745 13.5C26.5745 6.3203 20.7542 0.5 13.5745 0.5C6.39476 0.5 0.574463 6.3203 0.574463 13.5C0.574463 20.6797 6.39476 26.5 13.5745 26.5Z" fill="#037A9A" />
                          <path d="M16.8744 17.8H15.6744C15.0744 17.8 14.6744 17.4 14.6744 16.8V10.2C14.6744 9.59995 15.0744 9.19995 15.6744 9.19995H16.8744C17.4744 9.19995 17.8744 9.59995 17.8744 10.2V16.9C17.8744 17.4 17.4744 17.8 16.8744 17.8Z" fill="white" />
                          <path d="M11.4744 17.8H10.2744C9.67441 17.8 9.27441 17.4 9.27441 16.8V10.2C9.27441 9.59995 9.67441 9.19995 10.2744 9.19995H11.4744C12.0744 9.19995 12.4744 9.59995 12.4744 10.2V16.9C12.4744 17.4 12.0744 17.8 11.4744 17.8Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_1698_5897">
                            <rect width="26" height="26" fill="white" transform="translate(0.574463 0.5)" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </div>
                  <div className="me-4">{friendlyTimeBySecond(track_select?.file_info?.track_time / 1000)}</div>
                </div>
                <div className="filte-detail-wrapper">
                  <div className="">
                    <div>
                      <p className="dropzone-content">{track_select?.title}</p>
                    </div>
                    <div className={track_select?.album_info?.title ? "" : "nan"}>
                      Album: <span>{track_select?.album_info?.title ? track_select?.album_info?.title : 'N/A'}</span>
                    </div>
                    {track_select?.members?.map((member: any, mindex: number) => (
                      <div className={""} key={mindex}>
                        <span
                          className="focus"
                          onClick={() => window.open(`https://www.cumarket.net/artist/${member.id}i${track_select?.album_info?.id}`)}
                        >
                          {`${member.name} (${member.role})`}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="d-flex control right">

                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {loading ? (
        <LoadingWidget />
      ) : (
        <div id="ajaxContentRow">
          <div className="cont-wrapper" id="mainResultsContWrapper">
            <div className="uk-container-large">
              <div className="row">
                <div className="col-12">
                  {metatype?.map((type: any, index: number) => fileData.analyzedata && fileData.analyzedata[type.key] && (
                    <div key={index} className="result-main res-main-dynamic">
                      <div className="res-wrapper">
                        <a className="album-url" href={`https://www.cumarket.net/album/${fileData.analyzedata[type.key].album.id}`}>
                          <img className="album-cover" src={`https://img.cugate.com/?o=album&i=${fileData.analyzedata[type.key].album.id}&s=300`} alt="album" />
                        </a>
                        <div className="res-info">
                          <div className="row">
                            <div className="col-8">
                              <div className="res-info-main">
                                <div className="d-flex flex-column justify-content-center position-absolute">
                                  <div className="track-matchpercent">
                                    <span className="num">{Number.isInteger(Number(fileData.analyzedata[type.key].similarity_avg))?Number(fileData.analyzedata[type.key].similarity_avg):Number(fileData.analyzedata[type.key].similarity_avg).toFixed(1)}</span>
                                    <span className="perc">%</span>
                                  </div>
                                  <div className="track-searchtype">{type.title}</div>
                                </div>
                                <div className="track-title-members">
                                  <div className="track-title d-inline-block">
                                    <a href={fileData.analyzedata[type.key].track_url} target="_blank" rel="noreferrer">{fileData.analyzedata[type.key].track_title}</a>
                                    {/* <a href={fileData.analyzedata[type.key].track_url} target="_blank" rel="noreferrer">
                                                                        <img src="/imgs/merchbar_logo.png" alt="track"/>
                                                                    </a> */}
                                  </div>
                                  <div className="track-members">
                                    {fileData.analyzedata[type.key].members?.map((member: any, mindex: number) => (
                                      <div key={mindex} className="art-link-wrapper">
                                        <a className="art-link" target="_blank" href={member.url} rel="noreferrer">{member.title2}</a>
                                        <a className="merchbar_link" target="_blank" href={member.merch_url} rel="noreferrer">
                                          <img className="ms-1" src="/imgs/merchbar_logo.png" width="16" alt="track" />
                                        </a>
                                      </div>
                                    ))}
                                  </div>
                                  {type.key === 'fp_track' ? (
                                    <div className="fp_moreinfo">
                                      <div className="fp_params fp_key">{fileData.analyzedata[type.key].fp.key}</div>
                                      <div className="fp_params fp_mood">{fileData.analyzedata[type.key].fp.mood}</div>
                                    </div>
                                  ) : (<></>)}
                                </div>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="track-portal-links">
                                {fileData.analyzedata[type.key].culinks.ITUNES && (
                                  <div id="itunes_block" className="portal_block">
                                    <a target="_blank" href={fileData.analyzedata[type.key].culinks.ITUNES?.url} rel="noreferrer">
                                      <img className="ms-1" src="/imgs/Apple_icon.png" width="36" alt="track" />
                                    </a>
                                  </div>
                                )}
                                {fileData.analyzedata[type.key].culinks.AMAZON && (
                                  <div id="itunes_block" className="portal_block">
                                    <a target="_blank" href={fileData.analyzedata[type.key].culinks.AMAZON?.url} rel="noreferrer">
                                      <img className="ms-1" src="/imgs/Amazon_icon.png" width="36" alt="track" />
                                    </a>
                                  </div>
                                )}
                                {fileData.analyzedata[type.key].culinks.SPOTIFY && (
                                  <div id="itunes_block" className="portal_block">
                                    <a target="_blank" href={fileData.analyzedata[type.key].culinks.SPOTIFY?.url} rel="noreferrer">
                                      <img className="ms-1" src="/imgs/Spotify_icon.png" width="36" alt="track" />
                                    </a>
                                  </div>
                                )}
                                {fileData.analyzedata[type.key].culinks.DEEZER && (
                                  <div id="itunes_block" className="portal_block">
                                    <a target="_blank" href={fileData.analyzedata[type.key].culinks.DEEZER?.url} rel="noreferrer">
                                      <img className="ms-1" src="/imgs/Deezer_icon.png" width="36" alt="track" />
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-8">
                              <div className="track_playbar">
                                <div className="play-btn position-absolute focus" onClick={() => {
                                  let p = initPlaying;
                                  if (type.key === 'id3_track') p.id3_track = !playing.id3_track;
                                  if (type.key === 'fp_track') p.fp_track = !playing.fp_track;
                                  if (type.key === 'wm_track') p.wm_track = !playing.wm_track;
                                  setPlay({ ...p });
                                }}>
                                  {!playing[type.key] ? (
                                    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M13.0657 26.5C20.2454 26.5 26.0657 20.6797 26.0657 13.5C26.0657 6.3203 20.2454 0.5 13.0657 0.5C5.88597 0.5 0.0656738 6.3203 0.0656738 13.5C0.0656738 20.6797 5.88597 26.5 13.0657 26.5Z" fill="#00cbd8" />
                                      <path d="M9.38232 13.5V8.84165C9.38232 8.29998 9.92399 7.97498 10.4657 8.19165L14.474 10.4666L18.4823 12.7416C18.9157 12.9583 18.9157 13.7166 18.4823 13.9333L14.474 16.2083L10.4657 18.4833C10.0323 18.7 9.38232 18.375 9.38232 17.8333V13.5Z" fill="white" />
                                    </svg>
                                  ) : (
                                    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clipPath="url(#clip0_1698_5897)">
                                        <path d="M13.5745 26.5C20.7542 26.5 26.5745 20.6797 26.5745 13.5C26.5745 6.3203 20.7542 0.5 13.5745 0.5C6.39476 0.5 0.574463 6.3203 0.574463 13.5C0.574463 20.6797 6.39476 26.5 13.5745 26.5Z" fill="#00cbd8" />
                                        <path d="M16.8744 17.8H15.6744C15.0744 17.8 14.6744 17.4 14.6744 16.8V10.2C14.6744 9.59995 15.0744 9.19995 15.6744 9.19995H16.8744C17.4744 9.19995 17.8744 9.59995 17.8744 10.2V16.9C17.8744 17.4 17.4744 17.8 16.8744 17.8Z" fill="white" />
                                        <path d="M11.4744 17.8H10.2744C9.67441 17.8 9.27441 17.4 9.27441 16.8V10.2C9.27441 9.59995 9.67441 9.19995 10.2744 9.19995H11.4744C12.0744 9.19995 12.4744 9.59995 12.4744 10.2V16.9C12.4744 17.4 12.0744 17.8 11.4744 17.8Z" fill="white" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1698_5897">
                                          <rect width="26" height="26" fill="white" transform="translate(0.574463 0.5)" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  )}
                                </div>
                                <Waveform playing={playing[type.key]} url={`https://prelistening.cugate.com/?i=${fileData.analyzedata[type.key].track_id}&l=-1`} height={27} progressColor={'#00cbd8'} />
                                <div className="track-position" data-audio-id="main_FP">{fileData.analyzedata[type.key].track_time}</div>
                              </div>
                            </div>
                            <div className="col-4">
                              <DefaultButton
                                className="small-button"
                                textColor="var(--color-blue-light)"
                                color="var(--color-primary)"
                                borderColor="var(--color-blue-light)"
                                onClick={() => {
                                  let url = `https://www.cumarket.net/ytb/t-1-n`;
                                  if (fileData.analyzedata[type.key] && fileData.analyzedata[type.key].track_id && fileData.analyzedata[type.key].album && fileData.analyzedata[type.key].album.id)
                                    url = `https://www.cumarket.net/ytb/t-${fileData.analyzedata[type.key].track_id}-${fileData.analyzedata[type.key].album.id}`;
                                  window.open(url);
                                }}
                              >
                                <Icon name="cuview" width="17px" height="17px" color={"var(--color-blue-light)"} />
                                <span>CuView</span>
                              </DefaultButton>
                              <DefaultButton
                                className="small-button ms-2"
                                textColor="var(--color-blue-light)"
                                color="transparent"
                                borderColor="var(--color-blue-light)"
                                onClick={() => {
                                  let url = `https://curadio.net/trackstats.action?\
                                                                            slId=${fileData.analyzedata[type.key].track_id}&artist=\
                                                                            &track=${encodeURIComponent(fileData.analyzedata[type.key].track_title)}&disableLink=true`;
                                  setModalData({
                                    show: true,
                                    url: url,
                                  });
                                }}
                              >
                                <img src="/imgs/extsite_icon_radio.svg" style={{ width: '17px', height: '17px', marginLeft: '0px' }} alt="" />
                                <span>Radio</span>
                              </DefaultButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {fileData.analyzedata?.similars?(
          <div className="cont-wrapper" id="similiarResultsContWrapper">
            <div className="uk-container-large">
              <div className="row">
                <div className="col-12 text-center mt-3">
                  <h3 className="similars-header">
                    <span className="darkblue">Recommendations</span>
                    <span className="lightblue e-1">you might like</span>
                  </h3>
                </div>
                <div className="col-12">
                  {fileData.analyzedata?.similars?.map((track: any, index: number) => (
                    <div key={index} className="result-main res-main-dynamic">
                      <div className="res-wrapper">
                        <a className="album-url" href={`https://www.cumarket.net/album/${track.album.id}`}>
                          <img className="album-cover" src={`https://img.cugate.com/?o=album&i=${track.album.id}&s=300`} alt="album" />
                        </a>
                        <div className="res-info">
                          <div className="row">
                            <div className="col-8">
                              <div className="res-info-main">
                                <div className="d-flex flex-column justify-content-center position-absolute">
                                  <div className="track-matchpercent">
                                    <span className="num">{Number(track.similarity_avg).toFixed(1)}</span>
                                    <span className="perc">%</span>
                                  </div>
                                </div>
                                <div className="track-title-members">
                                  <div className="track-title d-inline-block">
                                    <a href={track.track_url} target="_blank" rel="noreferrer">{track.track_title}</a>
                                  </div>
                                  <div className="track-members">
                                    {track.members?.map((member: any, mindex: number) => (
                                      <div key={mindex} className="art-link-wrapper">
                                        <a className="art-link" target="_blank" href={member.url} rel="noreferrer">{member.title2}</a>
                                        <a className="merchbar_link" target="_blank" href={member.merch_url} rel="noreferrer">
                                          <img className="ms-1" src="/imgs/merchbar_logo.png" width="16" alt="track" />
                                        </a>
                                      </div>
                                    ))}
                                  </div>
                                  <div className="fp_moreinfo">
                                    <div className="fp_params fp_key">{track.fp?.key}</div>
                                    <div className="fp_params fp_mood">{track.fp?.mood}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="track-portal-links">
                                {track.culinks?.ITUNES && (
                                  <div id="itunes_block" className="portal_block">
                                    <a target="_blank" href={track.culinks?.ITUNES?.url} rel="noreferrer">
                                      <img className="ms-1" src="/imgs/Apple_icon.png" width="36" alt="track" />
                                    </a>
                                  </div>
                                )}
                                {track.culinks?.AMAZON && (
                                  <div id="itunes_block" className="portal_block">
                                    <a target="_blank" href={track.culinks?.AMAZON?.url} rel="noreferrer">
                                      <img className="ms-1" src="/imgs/Amazon_icon.png" width="36" alt="track" />
                                    </a>
                                  </div>
                                )}
                                {track.culinks?.SPOTIFY && (
                                  <div id="itunes_block" className="portal_block">
                                    <a target="_blank" href={track.culinks?.SPOTIFY?.url} rel="noreferrer">
                                      <img className="ms-1" src="/imgs/Spotify_icon.png" width="36" alt="track" />
                                    </a>
                                  </div>
                                )}
                                {track.culinks?.DEEZER && (
                                  <div id="itunes_block" className="portal_block">
                                    <a target="_blank" href={track.culinks?.DEEZER?.url} rel="noreferrer">
                                      <img className="ms-1" src="/imgs/Deezer_icon.png" width="36" alt="track" />
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-8">
                              <div className="track_playbar">
                                <div className="play-btn position-absolute focus" onClick={() => {
                                  setPlay({
                                    ...initPlaying,
                                    similiar: playing.similiar === -1 ? index : -1
                                  });
                                }}>
                                  {playing.similiar === index ? (
                                    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clipPath="url(#clip0_1698_5897)">
                                        <path d="M13.5745 26.5C20.7542 26.5 26.5745 20.6797 26.5745 13.5C26.5745 6.3203 20.7542 0.5 13.5745 0.5C6.39476 0.5 0.574463 6.3203 0.574463 13.5C0.574463 20.6797 6.39476 26.5 13.5745 26.5Z" fill="#037A9A" />
                                        <path d="M16.8744 17.8H15.6744C15.0744 17.8 14.6744 17.4 14.6744 16.8V10.2C14.6744 9.59995 15.0744 9.19995 15.6744 9.19995H16.8744C17.4744 9.19995 17.8744 9.59995 17.8744 10.2V16.9C17.8744 17.4 17.4744 17.8 16.8744 17.8Z" fill="white" />
                                        <path d="M11.4744 17.8H10.2744C9.67441 17.8 9.27441 17.4 9.27441 16.8V10.2C9.27441 9.59995 9.67441 9.19995 10.2744 9.19995H11.4744C12.0744 9.19995 12.4744 9.59995 12.4744 10.2V16.9C12.4744 17.4 12.0744 17.8 11.4744 17.8Z" fill="white" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1698_5897">
                                          <rect width="26" height="26" fill="white" transform="translate(0.574463 0.5)" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  ) : (
                                    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M13.0657 26.5C20.2454 26.5 26.0657 20.6797 26.0657 13.5C26.0657 6.3203 20.2454 0.5 13.0657 0.5C5.88597 0.5 0.0656738 6.3203 0.0656738 13.5C0.0656738 20.6797 5.88597 26.5 13.0657 26.5Z" fill="#037A9A" />
                                      <path d="M9.38232 13.5V8.84165C9.38232 8.29998 9.92399 7.97498 10.4657 8.19165L14.474 10.4666L18.4823 12.7416C18.9157 12.9583 18.9157 13.7166 18.4823 13.9333L14.474 16.2083L10.4657 18.4833C10.0323 18.7 9.38232 18.375 9.38232 17.8333V13.5Z" fill="white" />
                                    </svg>
                                  )}
                                </div>
                                <Waveform playing={playing.similiar === index} url={`https://prelistening.cugate.com/?i=${track.track_id}&l=-1`} height={27} waveColor={'#037A9A'} progressColor={'#00cbd8'} />
                                <div className="track-position" data-audio-id="main_FP">{track.track_time}</div>
                              </div>
                            </div>
                            <div className="col-4">
                              <DefaultButton
                                className="small-button"
                                textColor="var(--color-blue-light)"
                                color="transparent"
                                borderColor="var(--color-blue-light)"
                                onClick={() => {
                                  let url = `https://www.cumarket.net/ytb/t-1-n`;
                                  if (track.track_id && track.album && track.album.id)
                                    url = `https://www.cumarket.net/ytb/t-${track.track_id}-${track.album.id}`;
                                  window.open(url);
                                }}
                              >
                                <Icon name="cuview" width="17px" height="17px" color={"var(--color-blue-light)"} />
                                <span>CuView</span>
                              </DefaultButton>
                              <DefaultButton
                                className="small-button ms-2"
                                textColor="var(--color-blue-light)"
                                color="transparent"
                                borderColor="var(--color-blue-light)"
                                onClick={() => {
                                  let url = `https://curadio.net/trackstats.action?\
                                                                            slId=${track.track_id}&artist=\
                                                                            &track=${encodeURIComponent(track.track_title)}&disableLink=true`;
                                  setModalData({
                                    show: true,
                                    url: url,
                                  });
                                }}
                              >
                                <img src="/imgs/extsite_icon_radio.svg" style={{ width: '17px', height: '17px', marginLeft: '0px' }} alt="" />
                                <span>Radio</span>
                              </DefaultButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          ):(<>
          <div className="cont-wrapper" id="similiarResultsContWrapper">
            <div className="uk-container-large">
              <div className="row">
                <div className="col-12 text-center mt-3">
                  <h3 className="similars-header">
                    <span className="darkblue">There is no similar tracks</span>
                  </h3>
                </div>
              </div>
            </div>
            </div>
          </>)}
        </div>
      )}
      <Modal
        show={modalData.show}
        key={"modal_curadio"}
        // size="lg" //'sm' | 'lg' | 'xl'
        // backdrop="static"
        onHide={() => setModalData({ show: false, url: '' })}
        // centered
        dialogClassName="custom-modal modal-curadio"
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">Radio Monitoring</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe
            id="curadioFrame"
            title="curadioFrame"
            className="modal_curadio_frame"
            src={modalData.url}
            style={{ width: "100%", height: "359px", maxWidth: "978px", marginBottom: '12px' }}
          ></iframe>
        </Modal.Body>
      </Modal>
    </TrackLayout >
  );
};

export default TrackViewPage;
